import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_7.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/visionary');
  const shareText = encodeURIComponent('Visionary Leadership: Shaping Culture Through Forward-Thinking Impact!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Visionary Leadership — Outstanding Workplaces</title>
        <meta property="og:title" content="Visionary Leadership — Outstanding Workplaces" />
        <meta property="og:description" content="Visionary Leadership: Shaping Culture Through Forward-Thinking Impact" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777975222/i_7_hmu7rz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/visionary" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Visionary Leadership — Outstanding Workplaces" />
        <meta name="twitter:description" content="Visionary Leadership: Shaping Culture Through Forward-Thinking Impact" />
        <meta name="twitter:image" content="Visionary Leadership: Shaping Culture Through Forward-Thinking Impact" />
      </Helmet>

       <div className="sight_7_page_wrapper">
      <div className="sight_7_content_container">

        <div className="sight_7_section_one">

          {/* TITLE */}
          <h1 className="sight_7_page_title">
            Visionary Leadership: Shaping Culture Through Forward-Thinking Impact
          </h1>

          {/* ROW */}
          <div className="sight_7_row">

            {/* LEFT SIDE */}
            <div className="sight_7_left">
              <div className="sight_7_image_wrapper">
                <img
                  src="/assets/i_7.jpg"
                  alt="Team meeting discussion"
                  className="sight_7_blog_image"
                />
              </div>


                {/* SHARE SECTION */}
                <div className="sight_7_share_section">
                  <span className="sight_7_share_text">Share :</span>
                  <div className="sight_7_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_7_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_7_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_7_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_7_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

                <p className="sight_7_intro_paragraph">
                Visionary leaders set the tone for an organization’s culture by defining a clear purpose and inspiring teams to align with it. They don’t just manage they envision the future, champion innovation, and foster an environment where employees feel empowered to contribute their best ideas. By combining strategic foresight with empathy, visionary leaders create a culture of trust, collaboration, and continuous growth, making thought leadership a living part of everyday work.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_7_right">
              <div className="sight_7_ad_card">
                <img src="/assets/bc_1.png" className="sight_7_ad_bg" />
                <div className="sight_7_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_7_ad_badge" />

                <div className="sight_7_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_7_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_7_section">

          <div className="sight_7_topics">

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">The Role of Visionary Leadership in Shaping Company Culture</h2>
              <ul className="sight_7_topic_list">
                <li>Explore how leaders with a clear vision influence workplace values, employee engagement, and organizational identity.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">5 Traits of Visionary Leaders That Transform Workplaces</h2>
              <ul className="sight_7_topic_list">
                <li>Highlight key traits like foresight, empathy, innovation, adaptability, and communication that define effective visionary leaders.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">How Visionary Leadership Drives Employee Engagement and Retention</h2>
              <ul className="sight_7_topic_list">
                <li>Discuss the link between inspirational leadership and higher motivation, productivity, and loyalty among employees.</li>
              </ul>
            </div>
            

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Building a Culture of Innovation Through Visionary Leadership</h2>
              <ul className="sight_7_topic_list">
                <li>Show how leaders can foster creativity, experimentation, and continuous improvement in workplace culture.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Case Studies: Companies Thriving Under Visionary Leaders</h2>
              <ul className="sight_7_topic_list">
                <li>Analyze real-world examples of organizations where visionary leadership reshaped culture and drove success.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Visionary Leadership vs. Managerial Leadership: Impact on Culture</h2>
              <ul className="sight_7_topic_list">
                <li>Compare traditional management styles with visionary approaches and their effect on team morale and workplace culture.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">The Future of Work: How Visionary Leaders Prepare Organizations for Change</h2>
              <ul className="sight_7_topic_list">
                <li>Explore how forward-thinking leaders anticipate trends, embrace hybrid models, and adapt culture to evolving work environments.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Mentorship and Visionary Leadership: Developing Tomorrow’s Leaders</h2>
              <ul className="sight_7_topic_list">
                <li>Discuss how visionary leaders mentor employees and cultivate leadership potential across the organization.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Overcoming Cultural Resistance: How Visionary Leaders Inspire Change</h2>
              <ul className="sight_7_topic_list">
                <li>Focus on strategies leaders use to overcome skepticism and align teams with a new cultural vision.</li>
              </ul>
            </div>

            <div className="sight_7_topic_item">
              <h2 className="sight_7_topic_heading">Visionary Leadership and Employee Wellbeing: A Culture of Care</h2>
              <ul className="sight_7_topic_list">
                <li>Examine how leaders who prioritize vision also embed wellbeing, inclusion, and psychological safety into the workplace.</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;

